import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InnerSecurityRoutingModule } from './inner-security-routing.module';
import { RolesComponent } from './roles/roles.component';
import { RoleListTableComponent } from './roles/role-list-table/role-list-table.component';
import { RegisterNewRoleModalComponent } from './roles/modals/register-new-role-modal/register-new-role-modal.component';
import { RoleDetailComponent } from './roles/components/role-detail/role-detail.component';
import { AssignRolePermissionsModalComponent } from './roles/modals/assign-role-permissions-modal/assign-role-permissions-modal.component';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UsersComponent } from './users/users.component';
import { UsersListTableComponent } from './users/components/users-list-table/users-list-table.component';
import { UserRolesManagementComponent } from './users/components/user-roles-management/user-roles-management.component';
import { AssignUserRolesComponent } from './users/components/assign-user-roles/assign-user-roles.component';
import { AddUserComponent } from './users/components/add-user/add-user.component';
// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatTableModule,
  MatInputModule,
  MatChipsModule,
  MatCardModule,
  MatIconModule,
  MatDialogModule,
  MatSelectModule,
  MatMenuModule,
  MatPaginatorModule,
  MatCheckboxModule,
  MatProgressSpinnerModule
];

@NgModule({
  declarations: [
    RolesComponent,
    RoleListTableComponent,
    RegisterNewRoleModalComponent,
    RoleDetailComponent,
    AssignRolePermissionsModalComponent,
    UsersComponent,
    UsersListTableComponent,
    UserRolesManagementComponent,
    AssignUserRolesComponent,
    AddUserComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MATERIAL_MODULES,
    CdkMenuModule,
    InnerSecurityRoutingModule,
    TablerIconsModule.pick(TablerIcons),
  ],
  exports: [TablerIconsModule]
})
export class InnerSecurityModule { }
